import IconLoader from './loader';
import IconLogo from './logo';
import IconGitHub from './github';
import IconLinkedin from './linkedin';
import IconCodepen from './codepen';
import IconInstagram from './instagram';
import IconTwitter from './twitter';
import IconExternal from './external';
import IconFolder from './folder';
import IconLocation from './location';
import IconStar from './star';
import IconFork from './fork';
import IconZap from './zap';
import FormattedIcon from './formattedIcon';

export {
  IconLoader,
  IconLogo,
  IconGitHub,
  IconLinkedin,
  IconCodepen,
  IconInstagram,
  IconTwitter,
  IconExternal,
  IconFolder,
  IconLocation,
  IconStar,
  IconFork,
  IconZap,
  FormattedIcon,
};
